(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/wishlist-items
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @overview Wishlist list display.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @requires @cam/wishlist-button
 * -----------------------------------------------------------------------------
*/ if (customElements.get("wishlist-items") === undefined) {
    class WishlistItems extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            if (typeof Storage === "undefined") return;
            this.emptyMessage = this.querySelector("[data-wishlist-empty]");
            this.itemList = this.querySelector("[data-wishlist-items]");
            this.hidden = false;
            this.wishlist = this.getWishList();
            !this.wishlist || Object.keys(this.wishlist).length === 0 ? this.showEmptyState() : this.getProducts();
        // TODO
        // document.querySelectorAll('wishlist-button').forEach((item) => item.addEventListener('added', () => this.getProducts()));
        }
        getWishList() {
            const wishlist = localStorage.getItem("wishlist");
            return wishlist ? JSON.parse(wishlist) : {};
        }
        async getProducts() {
            Object.keys(this.wishlist).forEach(async (key)=>{
                this.loadingState(true);
                this.itemList.innerHTML = "";
                this.emptyMessage.hidden = true;
                const product = await fetch(`/products/${this.wishlist[key].handle}?section_id=card-product`).then((response)=>response.text()).then((responseText)=>{
                    return new DOMParser().parseFromString(responseText, "text/html");
                }).catch((error)=>this.errorHandler(error));
                const item = document.createElement("li");
                item.appendChild(product.body.firstChild);
                this.itemList.appendChild(item);
                item.querySelector("wishlist-button").addEventListener("removed", ()=>this.itemRemoved(item), false);
                this.loadingState(false);
            });
        }
        itemRemoved(item) {
            // TODO
            item.remove();
            this.wishlist = this.getWishList();
            if (Object.keys(this.wishlist).length === 0) this.showEmptyState();
        }
        loadingState(state) {
            state ? [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.add("loading")) : [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.remove("loading"));
        }
        errorHandler(error) {
            this.loadingState(false);
            console.error("An error has occured", error);
        }
        showEmptyState() {
            // TODO: Add aria support
            this.emptyMessage.hidden = false;
        }
    }
    customElements.define("wishlist-items", WishlistItems);
}



})();
